import { Box, Button, Typography } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";

export const BaseBudgetInputFilterForm = ({
  budgetParameters,
  formik,
  showFiscalDetails = true,
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          marginTop: 2,
          gap: 1,
        }}
      >
        {budgetParameters.length > 0 && showFiscalDetails === true && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "initial",
              marginRight: 1,
            }}
          >
            <Typography variant="subtitle1" component="div" fontWeight={"bold"}>
              {budgetParameters?.[0]?.dataEntryFiscalYearDate || "N/A"}
              {" - "}
              {`Version ` +
                `${budgetParameters?.[0]?.dataEntryFiscalYearVersion}`}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            size="small"
            title={"Select"}
            startIcon={<BusinessIcon />}
            color="success"
            onClick={formik.handleSubmit}
          >
            {"Select"}
          </Button>
        </Box>
      </Box>
    </>
  );
};
